import { cacheExchange, createClient, fetchExchange } from "urql";
import { createUrqlErrorRewriteExchange } from "./urqlErrorRewriteExchange";
export const urqlPublicClient = createClient({
    url: import.meta.env.VITE_PUBLIC_GRAPHQL_URL ||
        "http://localhost:4000/public",
    exchanges: [
        cacheExchange,
        createUrqlErrorRewriteExchange(),
        fetchExchange
    ]
});
